// Sagas are what field all the async requests in redux.  They make it easier
// to deal with this data, and also make it easier to test async calls from the ui
// You can read more about them here: https://github.com/redux-saga/redux-saga

import { all } from "redux-saga/effects";

import { watchTokenRequest, watchUnauthenticateToken } from "./token.sagas";
import { watchLoanRequest } from "./loadLoanDetails.sagas";
import { watchPaymentVerificationRequest } from "./verifyPayment.sagas";
import { watchPaymentSubmitRequest } from "./submitPayment.sagas";
import { watchAchInstitutionRequest } from "./achInstitution.sagas";
import { watchTransferFormRequest } from "./transferForm.sagas";
import {
  watchAuthCalcAchPostDate,
  watchAuthCalcAchPostDateV2,
  watchAuthCreatePaymentRecord,
  watchAuthFetchInternalAccounts,
  watchAuthGeneratePayoff,
  watchAuthGetLoanList,
  watchAuthPayoffCheck,
  watchAuthCancelFutureDatedPayment,
  watchAuthRecurringCancellation,
  watchAuthSaveDebitInfo,
  watchAuthSaveInternalInfo,
  watchAuthSubmitAch,
  watchAuthSubmitDebit,
  watchAuthSubmitTransfer,
  watchBeginAuthPaymentSession,
  watchAuthRefinanceRedirect,
} from "./authPayment.sagas";

import {
  watchAuthPostSkipSaga,
  watchAuthGetSkipInfoSaga,
  watchGetCardTypeSaga,
  watchAuthVerifySkipPaymentSaga,
} from "./authPaymentSkips.sagas";
import { watchGetMfaOptions, watchSubmitMfaCode, watchSubmitMfaPreference } from "./mfa.sagas";

import {
  watchBeginCardControlsSession,
  watchCardControlsGetCardList,
  watchCardControlsSaveCardStatus,
  watchCardControlsPinUpdate,
  watchCardControlsValidatePin,
  watchCardControlsGetMailingList,
  watchCardControlsGetBranches,
  watchSubmitCardReplacement,
  watchGetTravelExemptionEligibility,
  watchGetCardOwners,
  watchGetExistingTravels,
  watchSubmitTravelExemption,
  watchCancelExistingTravels,
} from "./cardControls.sagas";

export default function* rootSaga() {
  yield all([
    watchTokenRequest(),
    watchPaymentSubmitRequest(),
    watchPaymentVerificationRequest(),
    watchLoanRequest(),
    watchUnauthenticateToken(),
    watchAchInstitutionRequest(),
    watchTransferFormRequest(),
    watchBeginAuthPaymentSession(),
    watchAuthGetLoanList(),
    watchAuthCreatePaymentRecord(),
    watchAuthSaveDebitInfo(),
    watchAuthSubmitDebit(),
    watchAuthCalcAchPostDate(),
    watchAuthSubmitAch(),
    watchAuthFetchInternalAccounts(),
    watchAuthSaveInternalInfo(),
    watchAuthSubmitTransfer(),
    watchAuthCalcAchPostDateV2(),
    watchAuthCancelFutureDatedPayment(),
    watchAuthRecurringCancellation(),
    watchAuthPayoffCheck(),
    watchAuthGeneratePayoff(),
    watchAuthPostSkipSaga(),
    watchAuthGetSkipInfoSaga(),
    watchGetCardTypeSaga(),
    watchAuthRefinanceRedirect(),
    watchGetTravelExemptionEligibility(),
    watchGetMfaOptions(),
    watchSubmitMfaPreference(),
    watchSubmitMfaCode(),
    watchSubmitTravelExemption(),
    watchGetCardOwners(),
    watchGetExistingTravels(),
    watchCancelExistingTravels(),
    watchAuthVerifySkipPaymentSaga(),
    watchBeginCardControlsSession(),
    watchCardControlsGetCardList(),
    watchCardControlsSaveCardStatus(),
    watchCardControlsPinUpdate(),
    watchCardControlsValidatePin(),
    watchCardControlsGetMailingList(),
    watchCardControlsGetBranches(),
    watchSubmitCardReplacement(),
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/sagas.js